import React from "react";

const Stepper = ({ steps, currentStep }) => {
  return (
    <div className="flex items-center justify-between w-full">
      {steps.map((step, index) => {
        const active = index === currentStep;
        const completed = index < currentStep;

        return (
          <div key={step} className="flex items-center flex-1">
            <div className="flex items-center gap-2">
              <div
                className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold
                  ${
                    completed
                      ? "bg-green-600 text-white"
                      : active
                        ? "bg-blue-600 text-white"
                        : "bg-gray-300 dark:bg-gray-700"
                  }`}
              >
                {index + 1}
              </div>

              <span className={active ? "font-bold" : ""}>{step}</span>
            </div>

            {index < steps.length - 1 && (
              <div className="flex-1 h-[2px] bg-gray-300 mx-4" />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Stepper;
